export default __webpack_public_path__ + "static/media/2026-03-22 18.07.48.11dcbdf6.jpg";